import { AxiosInstance } from 'axios';
import { ArgumentValidator } from '../../helpers';
import { QueryStringBuilder } from '../helpers/query-string-builder';
import { IAgendaItem, IEditableAgendaItem, INewAgendaItem } from '../models/agenda';
import { IHierarchyNode } from '../models/hierarchy-node';

export class AgendaClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/agenda`;
    }

    public async getHierarchy(activityId: string, staleId?: string): Promise<IHierarchyNode<IAgendaItem>[]> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        try {

            const url = new QueryStringBuilder()
                .withQueryIfNotEmpty('staleId', staleId)
                .build(`${this.apiUrl}/${activityId}/hierarchy`);

            const response = await this.axiosClient.get(url);

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async create(activityId: string, agendaItem: INewAgendaItem, ignoreWsBroadcast: boolean = false): Promise<IAgendaItem> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(agendaItem, `agendaItem`);

        try {
            const response = await this.axiosClient.post(
                `${this.apiUrl}/item/${activityId}?ignoreWsBroadcast=${ignoreWsBroadcast}`,
                agendaItem,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async update(id: string, agendaItem: IEditableAgendaItem): Promise<IAgendaItem> {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        ArgumentValidator.notNullOrEmpty(agendaItem, `agendaItem`);

        try {
            const response = await this.axiosClient.put(
                `${this.apiUrl}/item/${id}`,
                agendaItem,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

            return response.data;

        } catch (error: any) {

            throw error.response.data;
        }
    }

    public async delete(id: string): Promise<void> {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        const response = await this.axiosClient.delete(`${this.apiUrl}/item/${id}`);

        return response.data;
    }

    public async updateSortOrder(activityId: string, orderedIds: string[], parentId?: string): Promise<void> {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);

        ArgumentValidator.notNullOrEmpty(orderedIds, `orderedIds`);

        try {
            const url = new QueryStringBuilder()
                .withQueryIfNotEmpty('parentId', parentId)
                .build(`${this.apiUrl}/${activityId}/sortOrder`);

            await this.axiosClient.put(
                url,
                orderedIds,
                {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
                }
            );

        } catch (error: any) {

            throw error.response.data;
        }
    }
}
